class SPARQLQueryDispatcher {
    constructor() {
        // Use direct URL for SPARQL queries - CORS is allowed for query.wikidata.org
        this.endpoint = "https://query.wikidata.org/sparql";
    }

    query(sparqlQuery, abortSignal = null) {
        const fullUrl = this.endpoint + '?query=' + encodeURIComponent(sparqlQuery);
        const headers = {
            'Accept': 'application/sparql-results+json',
            'User-Agent': 'EndolinkApp/1.0 (https://endo-link.ivia.ch/)'
        };

        const fetchOptions = {
            method: 'GET',
            headers,
            mode: 'cors'
        };

        // Add abort signal if provided
        if (abortSignal) {
            fetchOptions.signal = abortSignal;
        }

        return fetch(fullUrl, fetchOptions)
            .then(response => {
                if (!response.ok) {
                    let errorMessage;
                    switch (response.status) {
                        case 400:
                            errorMessage = `SPARQL Endpoint Error: 400 Bad Request. The request could not be understood or was missing required parameters.`;
                            break;
                        case 401:
                            errorMessage = `SPARQL Endpoint Error: 401 Unauthorized. Authentication is required and has failed or has not yet been provided.`;
                            break;
                        case 403:
                            errorMessage = `SPARQL Endpoint Error: 403 Forbidden. You do not have permission to access this resource.`;
                            break;
                        case 404:
                            errorMessage = `SPARQL Endpoint Error: 404 Not Found. The requested resource could not be found.`;
                            break;
                        case 500:
                            errorMessage = `SPARQL Endpoint Error: 500 Internal Server Error. The server encountered an unexpected condition.`;
                            break;
                        case 502:
                            errorMessage = `SPARQL Endpoint Error: 502 Bad Gateway. The server received an invalid response from an upstream server.`;
                            break;
                        case 503:
                            errorMessage = `SPARQL Endpoint Error: 503 Service Unavailable. The server is temporarily unable to handle the request. Please try again later.`;
                            break;
                        case 504:
                            errorMessage = `SPARQL Endpoint Error: 504 Gateway Timeout. The server did not receive a timely response from an upstream server.`;
                            break;
                        default:
                            errorMessage = `SPARQL Endpoint Error: ${response.status} ${response.statusText}. An unknown error occurred.`;
                    }
                    console.error(errorMessage);
                    throw new Error(errorMessage);
                }
                return response.json();
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    console.log('SPARQL query was cancelled');
                    throw new Error('Query cancelled by user');
                }
                console.error('Error in SPARQL query dispatcher:', error.message);
                throw error;
            });
    }
}

export default SPARQLQueryDispatcher;
